import { React, useState, useContext, useEffect, useMemo } from "react";
import { MTabs, Badge, Popover, Flex, Text, MLink, Heading } from "@cisco/spaces-dash-lib-styleguide";
import { v4 as uuidv4 } from "uuid";
import { NodeContext } from "../../contexts/nodeContext";
import * as BusinessHierarchyService from "../../service/business-hierarchy-service";
import LocationAccessPoints from "../location-accesspoints/location-accesspoints";
import LocationCameras from "../location-cameras/location-cameras";
import LocationSensors from "../location-sensors/location-sensors";
import LocationWebex from "../location-webex/location-webex";
import LocationSwitches from "../location-switches/location-switches";
import SecurityAppliance from "../security-appliance/security-appliance";
import "../business-location-details/business-location-details.scss";
import "../hierarchy-base/hierarchy-base.scss";
import { I18nContext } from "../../contexts/i18nContext";
import useLoader from "../../hooks/useLoader";
import "../../common/common_style.scss";
import "../../common/global_style.scss";
import "./network-devices-base.scss";
import { PropertiesContext } from "../../contexts/propertiesContext";

function NetworkDevicesBase(props) {
  const i18n = useContext(I18nContext);
  const { DASHBOARD_CLIENT_CUMULATIVE_INDEXEDDB: isCumulativeIndexeddb } = useContext(PropertiesContext) || {};
  const { selectedNode, locationRowMap } = props;
  const [node, setNode] = useState(selectedNode?.data);
  const { setLoading } = useLoader();
  const [newNodeLoaded, setNewNodeLoaded] = useState(false);
  const [apCount, setApCount] = useState(0);
  const [cameraCount, setCameraCount] = useState(0);
  const [webexCount, setWebexCount] = useState(0);
  const [sensorCount, setSensorCount] = useState(0);
  const [switchCount, setSwitchCount] = useState(0);
  const [spCount, setSpCount] = useState(0);
  const [controllers, setControllers] = useState([]);
  const [connectors, setConnectors] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
  const [showConnectorList, setShowConnectorList] = useState(false);
  const [showControllersList, setShowControllersList] = useState(false);
  const locationAccessPointsProvider = useMemo(
    () => ({
      node,
      setNode,
      apCount,
      setApCount,
      controllers,
      setConnectors,
      cameraCount,
      setCameraCount,
      sensorCount,
      setSensorCount,
      webexCount,
      setWebexCount,
      spCount,
      setSpCount,
      switchCount,
      setSwitchCount,
      locationRowMap
    }),
    [apCount, setApCount, sensorCount, setSensorCount, cameraCount, setCameraCount, webexCount, setWebexCount, spCount, setSpCount, switchCount, setSwitchCount]
  );

  const showNetworkDevicesTab = (tab) => {
    setSelectedTab(tab);
  };

  const connectorsSwitch = () => {
    setShowConnectorList((showConnectors) => !showConnectors);
    setShowControllersList(false);
  };

  const controllersSwitch = () => {
    setShowControllersList((showControllers) => !showControllers);
    setShowConnectorList(false);
  };

  const getAPCameraCounts = () => {
    console.log("node details");
    console.log(selectedNode);
    console.log(node);
    if (isCumulativeIndexeddb) {
      setApCount(selectedNode.data.totalApCount ? selectedNode.data.totalApCount : 0);
      setCameraCount(selectedNode.data.totalCameraCount ? selectedNode.data.totalCameraCount : 0);
      setWebexCount(selectedNode.data.totalWebExCount ? selectedNode.data.totalWebExCount : 0);
      setSensorCount(selectedNode.data.totalSensorCount ? selectedNode.data.totalSensorCount : 0);
      setSwitchCount(selectedNode.data.totalSwitchCount ? selectedNode.data.totalSwitchCount : 0);
      setSpCount(selectedNode.data.totalSACount ? selectedNode.data.totalSACount : 0);
    }
    let rootHasChildren = true;
    if (selectedNode && selectedNode.data && selectedNode.data.type && selectedNode.data.type[0] && selectedNode.data.type[0].toLowerCase() == "root") {
      if (!selectedNode.data.childData || selectedNode.data.childData.length == 0) {
        rootHasChildren = false;
      }
    }
    setLoading(true);
    BusinessHierarchyService.locationNetworkDeviceCount(selectedNode.data.id, rootHasChildren)
      .then((response) => {
        setLoading(false);
        if (response.status) {
          if (response.data) {
            console.log("NetworkDevicesBase: Success>>");
            if (!isCumulativeIndexeddb) {
              setApCount(response.data.apCount);
              setCameraCount(response.data.cameraCount);
              setWebexCount(response.data.webexCount);
              setSensorCount(response.data.sensorCount);
              setSwitchCount(response.data.switchCount);
              setSpCount(response.data.spCount);
            }
            if (response.data.controllers && response.data.controllers.length) {
              setControllers([...response.data.controllers]);
            }
            if (response.data.connectors && response.data.connectors.length) {
              setConnectors([...response.data.connectors.reverse()]);
            }
          }
          setTimeout(() => {
            setNewNodeLoaded(true);
            setSelectedTab("accesspoints");
          }, 100);
        } else {
          console.log(`locationNetworkDeviceCount: status false ::: ${response.message}`);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(`NetworkDevicesBase: Error on locationNetworkDeviceCount${error}`);
      });
  };

  useEffect(() => {
    console.log("NetworkDevicesBase Mount");
    if (selectedNode && selectedNode.data) {
      setNode(selectedNode.data);
      getAPCameraCounts();
      setShowConnectorList(false);
      setShowControllersList(false);
      console.log(`${showConnectorList} : ${showControllersList}`);
    }

    return () => {
      console.log("NetworkDevicesBase Destroy");
    };
  }, [selectedNode, apCount]);

  return (
    <>
      <div className="nw-wrapper">
        <div className="divTable">
          <div className="divTableRow">
            <div className="divTableCell">
              <div className="divTable" style={{ "margin-top": "22px" }}>
                <div className="nw-title" id="netork-device-title">
                  <Text size="p2" weight="regular" color="light">
                    {i18n.t("network-devices-base.network-device-connected")}
                  </Text>
                </div>
                <div className="divTableRow">
                  <MTabs kind="secondary" style={{ "padding-top": "15px", "padding-left": "24px" }}>
                    <MTabs.Link
                      id="network-access-point"
                      suffix={<Badge.Counter size="sm" value={apCount} />}
                      onClick={() => showNetworkDevicesTab("accesspoints")}
                      selected={selectedTab == "accesspoints"}
                    >
                      {i18n.t("location-access-points.access-points-text")}
                    </MTabs.Link>
                    <MTabs.Link suffix={<Badge.Counter size="sm" value={cameraCount} />} onClick={() => showNetworkDevicesTab("cameras")} selected={selectedTab == "cameras"} id="network-cameras">
                      {i18n.t("location-cameras.cameras-text")}
                    </MTabs.Link>
                    <MTabs.Link id="network-sp-devices" onClick={() => showNetworkDevicesTab("sp")} suffix={<Badge.Counter size="sm" value={spCount} />} selected={selectedTab == "sp"}>
                      {i18n.t("security-appliance.security-appliance")}
                    </MTabs.Link>
                    <MTabs.Link id="network-webex-devices" onClick={() => showNetworkDevicesTab("webex")} suffix={<Badge.Counter size="sm" value={webexCount} />} selected={selectedTab == "webex"}>
                      {i18n.t("network-devices-base.webex-devices")}
                    </MTabs.Link>
                    <MTabs.Link
                      id="network-linked-device"
                      onClick={() => showNetworkDevicesTab("sensors")}
                      suffix={<Badge.Counter size="sm" value={sensorCount} />}
                      selected={selectedTab == "sensors"}
                    >
                      {i18n.t("location-sensors.linked-devices")}
                    </MTabs.Link>
                    <MTabs.Link
                      id="network-switches-text"
                      onClick={() => showNetworkDevicesTab("switches")}
                      suffix={<Badge.Counter size="sm" value={switchCount} />}
                      selected={selectedTab == "switches"}
                    >
                      {i18n.t("network-devices-base.switches-text")}
                    </MTabs.Link>
                  </MTabs>
                </div>
              </div>
            </div>
            <div className="divTableCell" style={{ "border-bottom": "1px solid #d9d9d9" }}>
              <div className="divTable right-section">
                <div className="divTableRow">
                  {connectors && connectors.length > 0 && (
                    <div className="divTableCell">
                      <div className="wlc-device ignore-wlc-popup-click">
                        <Text size="p4" weight="regular" color="light">
                          {connectors.length}&nbsp;
                          {i18n.t("network-devices-base.connectors-text")}
                        </Text>
                      </div>
                      {connectors.length > 0 && (
                        <div className="wlc-item ignore-wlc-popup-click">
                          <Text size="p4" weight="regular">
                            {connectors[0].name}
                          </Text>
                        </div>
                      )}
                      {connectors.length > 1 && (
                        <div className="wlc-item ignore-wlc-popup-click">
                          <Text size="p4" weight="regular">
                            {connectors[1].name}
                          </Text>
                          {connectors.length > 2 && (
                            <span className="wlc-more-link ignore-wlc-popup-click" onClick={connectorsSwitch} role="presentation">
                              <Popover
                                placement="bottom"
                                style={{ height: "400px", overflow: "auto" }}
                                title={
                                  <Flex direction="vertical">
                                    <Heading size="sub-section" style={{ "padding-bottom": "5px" }}>
                                      {i18n.t("network-devices-base.connectors-text")}
                                    </Heading>
                                    {connectors.map((connector) => (
                                      <Text style={{ padding: "5px" }} size="p3" key={uuidv4()}>
                                        {connector.name}
                                      </Text>
                                    ))}
                                  </Flex>
                                }
                                kind="default"
                              >
                                <MLink className="hover-target">{`+ ${connectors.length - 2} ${i18n.t("network-devices-base.more-text")}`}</MLink>
                              </Popover>
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {controllers && controllers.length > 0 && (
                    <div className="divTableCell width220" style={{ float: "right !important" }}>
                      <div className="wlc-device ignore-wlc-popup-click">
                        <Text size="p4" weight="regular" color="light">
                          {controllers.length}&nbsp;
                          {i18n.t("network-devices-base.controllers-text")}
                        </Text>
                      </div>
                      {controllers.length > 0 && (
                        <div className="wlc-item ignore-wlc-popup-click">
                          <Text size="p4" weight="regular">
                            {controllers[0].name}
                          </Text>
                        </div>
                      )}
                      {controllers.length > 1 && (
                        <div className="wlc-item ignore-wlc-popup-click">
                          <Text size="p4" weight="regular">
                            {controllers[1].name}
                          </Text>
                          {controllers.length > 2 && (
                            <span className="wlc-more-link ignore-wlc-popup-click" onClick={controllersSwitch} role="presentation">
                              <Popover
                                placement="bottom"
                                style={{ height: "400px", overflow: "auto" }}
                                title={
                                  <Flex direction="vertical">
                                    <Heading size="sub-section" style={{ "padding-bottom": "5px" }}>
                                      {i18n.t("network-devices-base.controllers-text")}
                                    </Heading>
                                    {controllers.map((controller) => (
                                      <Text style={{ padding: "3px" }} size="p3" key={uuidv4()}>
                                        {controller.name}
                                      </Text>
                                    ))}
                                  </Flex>
                                }
                                kind="default"
                              >
                                <MLink className="hover-target">{`+ ${controllers.length - 2} ${i18n.t("network-devices-base.more-text")}`}</MLink>
                              </Popover>
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {newNodeLoaded && (
        <div className="nw-tab-wrapper">
          {(() => {
            switch (selectedTab) {
              case "accesspoints":
                return (
                  <NodeContext.Provider value={locationAccessPointsProvider}>
                    <LocationAccessPoints />
                  </NodeContext.Provider>
                );

              case "cameras":
                return (
                  <NodeContext.Provider value={locationAccessPointsProvider}>
                    <LocationCameras />
                  </NodeContext.Provider>
                );

              case "webex":
                return (
                  <NodeContext.Provider value={locationAccessPointsProvider}>
                    <LocationWebex />
                  </NodeContext.Provider>
                );

              case "sp":
                return (
                  <NodeContext.Provider value={locationAccessPointsProvider}>
                    <SecurityAppliance />
                  </NodeContext.Provider>
                );

              case "sensors":
                return (
                  <NodeContext.Provider value={locationAccessPointsProvider}>
                    <LocationSensors />
                  </NodeContext.Provider>
                );

              case "switches":
                return (
                  <NodeContext.Provider value={locationAccessPointsProvider}>
                    <LocationSwitches />
                  </NodeContext.Provider>
                );

              default:
                return "";
            }
          })()}
        </div>
      )}
    </>
  );
}

export default NetworkDevicesBase;
